// extracted by mini-css-extract-plugin
export default {"container":"nkcYwikP","title":"pM8PGgTe","value":"UMRc4l2I","primaryText":"eZNOtjYn","secondaryText":"wfRmC3vN","graph":"LcjjjaqC"};